import { type Member } from '@/features/iam/members/Member'
import { type NotificationsApi } from '@/features/notifications/api/notifications-api'
import { Id } from '@/infra/id'
import {
  mapNotificationPreferencesResourceToPreferences,
  mapNotificationPreferencesToRequest,
} from './notification-mappers'
import { type NotificationPreferences } from './notification-preferences'

/**
 * Notification preferences store.
 */
export class NotificationPreferencesStore {
  constructor(private readonly _api: NotificationsApi) {}

  /**
   * Gets the preferences for the member.
   *
   * @param member
   * @param signal
   */
  async fetchPreferences(
    member: Member,
    signal?: AbortSignal,
  ): Promise<NotificationPreferences> {
    const resource = await this._api.preferences.get(
      Id.assert(member.workspace.id),
      Id.assert(member.user.publicId),
      signal,
    )
    return mapNotificationPreferencesResourceToPreferences(resource)
  }

  /**
   * Saves the preferences for the member.
   *
   * @param member
   * @param preferences
   */
  async savePreferences(
    member: Member,
    preferences: NotificationPreferences,
  ): Promise<void> {
    await this._api.preferences.patch(
      Id.assert(member.workspace.id),
      Id.assert(member.user.publicId),
      mapNotificationPreferencesToRequest(preferences),
    )
  }
}
